import type { HomepageVideoState } from '@web-platform/shared-universal-types/src/redux/banana/state/combinedResults/entitiesSearchResults/adverts/homepageVideo';

export const INITIAL_STATE: HomepageVideoState = {
  byId: {},
};
